// Entra, Intune and the Azure portal all share the AAD group blade; deep-link to the
// group's overview in the Intune admin center for anything RBACMan doesn't cover.
export const intuneGroupUrl = (id: string) =>
  `https://intune.microsoft.com/#view/Microsoft_AAD_IAM/GroupDetailsMenuBlade/~/Overview/groupId/${id}`;

// Same shared AAD blade, user variant — deep-link to the user's overview in the Intune
// admin center for account actions RBACMan doesn't cover (e.g. enable/disable).
export const intuneUserUrl = (id: string) =>
  `https://intune.microsoft.com/#view/Microsoft_AAD_IAM/UserDetailsMenuBlade/~/overview/userId/${id}`;
